export const FETCH_APP_TOKEN_REQUEST = 'FETCH_APP_TOKEN_REQUEST'
export const FETCH_APP_TOKEN_SUCCESS = 'FETCH_APP_TOKEN_SUCCESS'
export const FETCH_APP_TOKEN_FAILURE = 'FETCH_APP_TOKEN_FAILURE'
export const FETCH_APP_TOKEN = 'FETCH_APP_TOKEN'
export const CLEAR_APP_TOKEN = 'CLEAR_APP_TOKEN'

export const CREATE_NEW_PLAN_REQUEST = 'CREATE_NEW_PLAN_REQUEST'
export const CREATE_NEW_PLAN_SUCCESS = 'CREATE_NEW_PLAN_SUCCESS'
export const CREATE_NEW_PLAN_FAILURE = 'CREATE_NEW_PLAN_FAILURE'
export const UPDATE_PLAN_REQUEST = 'UPDATE_PLAN_REQUEST'
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS'
export const UPDATE_PLAN_FAILURE = 'UPDATE_PLAN_FAILURE'
export const CLEAR_PLAN = 'CLEAR_PLAN'

export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST'
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS'
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE'
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS'

export const LOAD_PLAN_REQUEST = 'LOAD_PLAN_REQUEST'
export const LOAD_PLAN_SUCCESS = 'LOAD_PLAN_SUCCESS'
export const LOAD_PLAN_FAILURE = 'LOAD_PLAN_FAILURE'

export const DELETE_PLAN_REQUEST = 'DELETE_PLAN_REQUEST'
export const DELETE_PLAN_SUCCESS = 'DELETE_PLAN_SUCCESS'
export const DELETE_PLAN_FAILURE = 'DELETE_PLAN_FAILURE'

export const EXPORT_PLAN_TO_EXCEL_REQUEST = 'EXPORT_PLAN_TO_EXCEL_REQUEST'
export const EXPORT_PLAN_TO_EXCEL_SUCCESS = 'EXPORT_PLAN_TO_EXCEL_SUCCESS'
export const EXPORT_PLAN_TO_EXCEL_FAILURE = 'EXPORT_PLAN_TO_EXCEL_FAILURE'

export const UNAUTHORIZED_MESSAGE = 'Error: Request failed with status code 401'

export const DASHBOARD_PATH = '/dashboard'
export const LOGIN_PATH = '/'
export const LOAD_PLAN_PATH = '/plan/:plan_id'
export const PASSWORD_RESET_PATH = '/password_reset'
export const PASSWORD_CHANGE_PATH = '/password_change/:token'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

export const SYSTEM_TITLE = 'Risk Planning System'

export const CREATE_CONTROL_REQUEST = 'CREATE_CONTROL_REQUEST'
export const CREATE_CONTROL_SUCCESS = 'CREATE_CONTROL_SUCCESS'
export const CREATE_CONTROL_FAILURE = 'CREATE_CONTROL_FAILURE'
export const UPDATE_CONTROL_REQUEST = 'UPDATE_CONTROL_REQUEST'
export const UPDATE_CONTROL_SUCCESS = 'UPDATE_CONTROL_SUCCESS'
export const UPDATE_CONTROL_FAILURE = 'UPDATE_CONTROL_FAILURE'
export const DELETE_CONTROL_REQUEST = 'DELETE_CONTROL_REQUEST'
export const DELETE_CONTROL_SUCCESS = 'DELETE_CONTROL_SUCCESS'
export const DELETE_CONTROL_FAILURE = 'DELETE_CONTROL_FAILURE'
export const GET_UNIQUE_CONTROL_REQUEST = 'GET_UNIQUE_CONTROL_REQUEST'
export const GET_UNIQUE_CONTROL_SUCCESS = 'GET_UNIQUE_CONTROL_SUCCESS'
export const GET_UNIQUE_CONTROL_FAILURE = 'GET_UNIQUE_CONTROL_FAILURE'

export const TOGGLE_RISK_REQUEST = 'TOGGLE_RISK_REQUEST'
export const TOGGLE_RISK_SUCCESS = 'TOGGLE_RISK_SUCCESS'
export const TOGGLE_RISK_FAILURE = 'TOGGLE_RISK_FAILURE'

export const UPDATE_RISK_REQUEST = 'UPDATE_RISK_REQUEST'
export const UPDATE_RISK_SUCCESS = 'UPDATE_RISK_SUCCESS'
export const UPDATE_RISK_FAILURE = 'UPDATE_RISK_FAILURE'

export const UPDATE_TAGS_REQUEST = 'UPDATE_TAGS_REQUEST'
export const UPDATE_TAGS_SUCCESS = 'UPDATE_TAGS_SUCCESS'
export const UPDATE_TAGS_FAILURE = 'UPDATE_TAGS_FAILURE'

export const CLEAR_RISK = 'CLEAR_RISK'
export const CLEAR_CONTROL = 'CLEAR_CONTROL'
export const CLEAR_TAGS = 'CLEAR_TAGS'



// WEBPACK FOOTER //
// ./src/constants.js